import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const Link = styled(props => <RouterLink {...props} />)`
  text-decoration: none;
  color: inherit;
`;

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.js